module.exports = __webpack_public_path__ + "img/rightthigh-endomorph-male.505e754d.svg";